var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoProspecting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.2538H18.7343C18.405 16.2463 18.1193 16.0258 18.0285 15.7093L15.6532 7.3963L14.2027 11.2671C14.0925 11.5596 13.8128 11.7538 13.5 11.7538H10.5V10.2538H12.9803L15.0473 4.74055C15.162 4.43755 15.456 4.24255 15.78 4.25455C16.104 4.2673 16.3822 4.4863 16.4715 4.79755L18.8048 12.9666L20.289 8.5168C20.391 8.21005 20.6768 8.0038 21 8.0038H24V9.5038H21.5407L19.461 15.7408C19.359 16.0483 19.0725 16.2538 18.75 16.2538Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 21.5H9.75V16.25C9.7485 15.008 8.742 14.0015 7.5 14H4.5C3.258 14.0015 2.2515 15.008 2.25 16.25V21.5H0.75V16.25C0.75225 14.18 2.43 12.5022 4.5 12.5H7.5C9.57 12.5022 11.2478 14.18 11.25 16.25V21.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3.5C3.92925 3.5 2.25 5.17925 2.25 7.25C2.25 9.32075 3.92925 11 6 11C8.07075 11 9.75 9.32075 9.75 7.25C9.75 5.17925 8.07075 3.5 6 3.5ZM6 5C7.24275 5 8.25 6.00725 8.25 7.25C8.25 8.49275 7.24275 9.5 6 9.5C4.75725 9.5 3.75 8.49275 3.75 7.25C3.7515 6.008 4.758 5.0015 6 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoProspecting);
export default __webpack_public_path__ + "static/media/auto-prospecting.9d13243c11003c5034898dfd9bd79d06.svg";
export { ForwardRef as ReactComponent };